import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7a2d538e")

_pushScopeId("data-v-7a2d538e")
const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "page__body" }
const _hoisted_3 = { class: "documentation__group" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "route__title" }
const _hoisted_6 = { class: "route__description" }
const _hoisted_7 = { class: "row__body" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = /*#__PURE__*/_createVNode("h5", null, "Input", -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("h5", null, "Output", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("ul", null, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.routes, (route, idx) => {
            return (_openBlock(), _createBlock("li", { key: idx }, [
              _createVNode("i", {
                class: _ctx.expandedClass(idx),
                onClick: ($event: any) => (_ctx.toggle(idx))
              }, null, 10, ["onClick"]),
              _createVNode("div", _hoisted_4, [
                _createVNode("div", {
                  class: ["row__title", _ctx.rowClass(route)]
                }, [
                  _createVNode("div", {
                    class: ["route__type", _ctx.badgeClass(route)]
                  }, [
                    _createVNode("span", null, _toDisplayString(_ctx.reqtype(route)), 1)
                  ], 2),
                  _createVNode("div", _hoisted_5, [
                    _createVNode("span", null, _toDisplayString(route), 1)
                  ]),
                  _createVNode("div", _hoisted_6, _toDisplayString(_ctx.descr(route)), 1)
                ], 2),
                _createVNode("div", _hoisted_7, [
                  (_ctx.expanded[idx])
                    ? (_openBlock(), _createBlock("div", _hoisted_8, [
                        (_ctx.input(route) !== undefined)
                          ? (_openBlock(), _createBlock("div", _hoisted_9, [
                              _hoisted_10,
                              _createVNode("pre", {
                                innerHTML: _ctx.pretty(_ctx.input(route)?.type)
                              }, null, 8, ["innerHTML"])
                            ]))
                          : _createCommentVNode("", true),
                        _createVNode("div", null, [
                          _hoisted_11,
                          _createVNode("pre", {
                            innerHTML: _ctx.pretty(_ctx.output(route)?.type)
                          }, null, 8, ["innerHTML"])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
})